import React from "react";
import { Typography } from "antd";

import { W0 } from "@components/Constants";

type Props = {
  text: string;
};

const Text = ({ text }: Props): JSX.Element => {
  const labelStyle = {
    paddingTop: W0 / 2,
    paddingLeft: W0,
  };

  return (
    <Typography.Paragraph style={labelStyle}>
      {text}
    </Typography.Paragraph>
  );
};

export default Text;
